<dx-popup
  [showTitle]="true"
  title="Suppression impossible"
  [visible]="suppressionBloqueeList().length > 0"
  (onHidden)="closeDialog()"
  [width]="'60%'"
  [height]="'auto'"
  [maxHeight]="'80%'"
  [resizeEnabled]="true"
  [showCloseButton]="true">

  <p>
    Les autres modifications ont été enregistrées, mais des effectifs sont encore saisis sur les produits
    complémentaires ci-dessous : ils n'ont pas été supprimés. Mettez ces effectifs à zéro, puis supprimez-les à nouveau.
  </p>

  <dx-data-grid
    [dataSource]="suppressionBloqueeList()"
    [showBorders]="true"
    [showRowLines]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    columnResizingMode="widget"
    noDataText="Pas de données">

    <dxi-column dataField="produitLibelle" caption="Produit"></dxi-column>
    <dxi-column caption="Jours concernés" [calculateCellValue]="joinDateEffectif"></dxi-column>
  </dx-data-grid>
</dx-popup>
